<template>
<div id="transaction-tag">
  <multiselect

    :class="errorClass"
    :tag-placeholder="tagPlaceholder"
    :placeholder="placeholder"
    :deselectLabel="deselectLabel"
    :selectLabel="selectLabel"
    :selectedLabel="selectedLabel"
    :hideSelected="hideSelected"
    :label="label"
    track-by="name"
    :options="optionList"
    :multiple="allowMultiple"
    :taggable="allowTaggable"
    :value="valueOptions"
    :searchable="searchable"
    :close-on-select="closeOnSelect"
    :internalSearch="internalSearch"
    :openDirection="openDirection"
    :disabled="disabled"
    :showNoResults="showNoResults"
    :showNoOptions="showNoOptions"
    :options-limit="100"
    @tag="createOption"
    @remove="removeItem"
    @select="selectItem"
    @close="emitClose"
    @open="emitOpen"
  >

  <template slot="option" slot-scope="{option}" v-if="useOptionSlot">
    <div class="title" v-if="option.optionType === 'TITLE'">
      <span class="label form--label">{{$t(option.name).toUpperCase()}}</span>
    </div>
    <div class="highlighted" v-if="option.optionType === 'OPTION'">
    <span class="item" > {{option.name}}</span>
    </div>
    <div class="separator" v-if="option.optionType ==='SEPARATOR'"></div>
  </template>

    <div
      class="caret"
      slot="caret"
      slot-scope="{ toggle }"
      @mousedown.prevent.stop="toggle"
    >
      <i
        class="Ctrl Ctrl--16"
        aria-hidden="true"
      >
        <svg
          focusable="false"
          aria-hidden="true"
          aria-label="Edit"
        >
          <use xlink:href="#dropdown-icon"></use>
        </svg>
      </i>
    </div>
    <template slot="noResult">
      <span class="no-result">
        {{$t(noResultLabel)}}
      </span>
    </template>
    <template slot="noOptions">
      <span class="no-result">
        {{$t(noOptionsLabel)}}
      </span>
    </template>
  </multiselect>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  name: 'OptionSettingsInput',
  props: {
    errorClass: {
      type: String
    },
    searchable: {
      type: Boolean,
      default: true
    },
    tagPlaceholder: {
      type: String,
      default: ''
    },
    allowTaggable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    showOptions: {
      type: Boolean,
      default: true
    },
    noOptionsLabel: {
      type: String,
      default: 'multiselect_no_options_slot_default'
    },
    noResultLabel: {
      type: String,
      default: 'multiselect_no_result_slot_default'
    },
    deselectLabel: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: ''
    },
    selectedLabel: {
      type: String,
      default: ''
    },
    hideSelected: {
      type: Boolean,
      default: false
    },
    alternateOptions: {
      type: Array,
      default: () => []
    },
    overrideValue: {
      type: [Array, Object]
    },
    allowMultiple: {
      type: Boolean,
      default: true
    },
    emitTagTypeOnClose: {
      type: Boolean,
      default: false
    },
    customField: {
      type: Object
    },
    closeOnSelect: {
      type: Boolean
    },
    internalSearch: {
      type: Boolean
    },
    openDirection: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'name'
    },
    showNoResults: {
      type: Boolean,
      default: false
    },
    showNoOptions: {
      type: Boolean,
      default: false
    },
    useOptionSlot: {
      type: Boolean,
      default: false
    }

  },
  components: { Multiselect },
  data () {
    return {
      options: [],
      value: [],
      id: 1
    }
  },
  computed: {
    optionList () {
      if (this.showOptions) {
        if (this.alternateOptions.length > 0) {
          return this.alternateOptions
        } else {
          return this.options
        }
      }
      return []
    },
    valueOptions () {
      if (this.overrideValue) {
        return this.overrideValue
      } else {
        return this.value
      }
    }
  },
  methods: {
    createOption (option) {
      const newOption = {
        name: option,
        id: this.id
      }
      this.id++
      this.options.push(newOption)
      this.value.push(newOption)
      this.$emit('tag', newOption)
    },
    removeItem (item) {
      if (this.customField) {
        const fieldToRemove = {
          tagType: this.customField,
          tagToRemove: item,
          values: this.valueOptions
        }
        this.$emit('remove', fieldToRemove)
      } else {
        const { id, name } = item
        if (id) {
          this.$emit('remove', id)
        }
        if (name) {
          this.$emit('remove', name)
        }
      }
    },
    selectItem (item) {
      this.$emit('select', item)
    },
    emitOpen (event) {
      if (this.emitTagTypeOnClose) {
        const fieldToValidate = {
          tagType: this.customField,
          values: this.valueOptions
        }

        this.$emit('open', fieldToValidate)
      } else {
        this.$emit('open', event)
      }
    },
    emitClose (event) {
      if (this.emitTagTypeOnClose) {
        const fieldToValidate = {
          tagType: this.customField,
          values: this.valueOptions
        }

        this.$emit('close', fieldToValidate)
      } else {
        this.$emit('close', event)
      }
    }

  }

}
</script>

<style  src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#transaction-tag {

  .multiselect__option--highlight > .highlighted > .item {
      color: var(--text-body);
      opacity: 1 !important;
    }
  .multiselect__option--selected > .highlighted > .item {
      font-weight: 400;
      outline: none;
      color: var(--text-heading) !important;
    }
  .multiselect .multiselect__option:has(.separator)
   {
    padding: 10px 5px;
    min-height: 10px;
  }

  .multiselect .multiselect__option:has(.title) {
    padding:7px 12px;
    min-height:24px;
  }

  .separator {
      background-color: var(--fill-divider);
      width: 100%;
      height: 1px;
    }
}

</style>
